/** Image affichée par les annuaires lorsqu'un profil n'a pas de photo. */
export const NO_PHOTO = 'assets/images/no-photo.svg';

/**
 * Repli sur l'image par défaut quand une photo ne se charge pas (fichier
 * supprimé, lien expiré…). La vérification évite une boucle si l'image par
 * défaut elle-même était introuvable.
 */
export function fallbackToNoPhoto(event: Event): void {
  const img = event.target as HTMLImageElement | null;
  if (!img || img.src.endsWith(NO_PHOTO)) return;
  img.src = NO_PHOTO;
  img.classList.add('is-placeholder');
}
